import {useServices} from '@/services/context'
import {useQuery} from '@tanstack/react-query'

export function useObservabilityHealth() {
    const services = useServices()
    return useQuery({
        queryKey: ['observability', 'health'],
        queryFn: () => services.observability.health(),
        refetchInterval: 30000,
    })
}

export function useTraceList(queryString: string) {
    const services = useServices()
    return useQuery({
        queryKey: ['observability', 'traces', queryString],
        queryFn: () => services.observability.traces(Object.fromEntries(new URLSearchParams(queryString))),
        refetchInterval: 30000,
    })
}

export function useTrace(sessionId: string | undefined) {
    const services = useServices()
    return useQuery({
        queryKey: ['observability', 'trace', sessionId],
        queryFn: () => services.observability.trace(encodeURIComponent(sessionId!)),
        enabled: !!sessionId,
    })
}

